import type { RemoveRingAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { YinshState } from "../types/game-state";
import { getCellContent } from "../utils/board-utils";

export function validateRemoveRing(
  state: YinshState,
  action: RemoveRingAction,
): ValidationResult {
  if (state.phase !== "REMOVING_ROW") {
    return { valid: false, error: "Not in row removal phase" };
  }
  if (action.player !== state.currentPlayer) {
    return { valid: false, error: "Not your turn" };
  }
  if (state.pendingRows.length > 0) {
    return { valid: false, error: "Must select and remove a row first" };
  }
  const cell = getCellContent(state.board, action.position);
  if (cell?.type !== "RING" || cell.player !== action.player) {
    return { valid: false, error: "No friendly ring at that position" };
  }
  return { valid: true };
}
